// extracted by mini-css-extract-plugin
module.exports = {"horizontalTable":"styles__horizontalTable____yoPQ"};